import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  setContext,
  from,
  onError
} from "graphql/apollo"
import config from "config/config"
import { getFromStorage } from "main/util/LocalStorageHelper"
import { eAccumulator } from "main/common/errorAccumulator"

const nebula = "nebula"

const httpLink = createHttpLink({
  uri: config[nebula].url
})

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach((error) => {
      eAccumulator.call(error)
    })
})

const authLink = setContext((_, { headers }) => {
  const user = getFromStorage("user")
  const token = user ? user.token : ""
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  }
})

const gqlClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache()
})

export default gqlClient
